// extracted by mini-css-extract-plugin
export default {"unity_activity_rule":"style_unity_activity_rule__fnsvM"};